import React from 'react'
import './TrustpilotSection.css'

const TrustpilotSection = () => {
  return (
    <div className="kuCMFf">
      <div className="b_L6f_">
        <div className="ada7vA">
          <div className="_2516Jo">
            <a
              target="_blank"
              className="wIL4xY b1fq0I"
              href="https://trustpilot.com/review/amlbot.com"
              rel="noopener noreferrer"
            >
            </a>
          </div>
          <div className="Uz3_Ic">
            <div className="HtuBmR">We are trusted members of</div>
            <ul className="qQncdT">
              <li>
                <img
                  alt="International Association for Trusted Blockchain Applications"
                  loading="lazy"
                  width="64"
                  height="64"
                  decoding="async"
                  data-nimg="1"
                  style={{ color: 'transparent' }}
                  src="https://amlbot.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2FINATBA.9636cc23.webp&w=96&q=75"
                />
                <span>INATBA</span>
              </li>
              <li>
                <img
                  alt="Crypto Defenders Alliance"
                  loading="lazy"
                  width="64"
                  height="64"
                  decoding="async"
                  data-nimg="1"
                  style={{ color: 'transparent' }}
                  src="https://amlbot.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2FCDA.d7fac033.webp&w=96&q=75"
                />
                <span>CDA</span>
              </li>
              <li>
                <img
                  alt="Anti-Human Trafficking Intelligence Initiative"
                  loading="lazy"
                  width="64"
                  height="64"
                  decoding="async"
                  data-nimg="1"
                  style={{ color: 'transparent' }}
                  src="https://amlbot.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2FATII.cf0e185d.webp&w=96&q=75"
                />
                <span>ATII</span>
              </li>
              <li>
                <img
                  alt="League for Security in the Web3"
                  loading="lazy"
                  width="64"
                  height="64"
                  decoding="async"
                  data-nimg="1"
                  style={{ color: 'transparent' }}
                  src="https://amlbot.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2FLSW3.f1348f65.webp&w=96&q=75"
                />
                <span>LSW3</span>
              </li>
              <li>
                <img
                  alt="EU Blockchain Association"
                  loading="lazy"
                  width="64"
                  height="64"
                  decoding="async"
                  data-nimg="1"
                  style={{ color: 'transparent' }}
                  src="https://amlbot.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2FEBA.a1002461.webp&w=96&q=75"
                />
                <span>ЕВА</span>
              </li>
              <li>
                <img
                  alt="FinTech Association of Hong Kong"
                  loading="lazy"
                  width="200"
                  height="200"
                  decoding="async"
                  data-nimg="1"
                  style={{ color: 'transparent' }}
                  src="https://amlbot.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2FFTAHK.a46bf924.webp&w=256&q=75"
                />
                <span>FTAHK</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TrustpilotSection
